import { Subject } from 'rxjs';
import {
  Component,
  OnInit,
  Input,
  OnChanges,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { tap } from 'rxjs/operators';

export interface SortVM {
  id: string | number;
  isAsc: boolean;
}

@Component({
  selector: 'app-up-down-sort',
  template: `
    <i class="fa fa-sort inactiveSort pl-2" *ngIf="!isActive; else active"></i>

    <ng-template #active>
      <i
        class="fa pl-2"
        [ngClass]="{ 'fa-sort-up': sortAsc, 'fa-sort-down': !sortAsc }"
      ></i>
    </ng-template>
  `,
  styles: [
    `
      .inactiveSort {
        color: #e3e3e3 !important;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpDownSortComponent implements OnInit, OnChanges {

  @Input()
  id: string | number;

  // which id to sort
  @Input()
  sortBy$: Subject<string | number> = new Subject();

  @Output()
  onChangeSort: EventEmitter<SortVM> = new EventEmitter();

  @Input()
  isActive: boolean = false;

  @Input()
  sortAsc: boolean = true;

  constructor(
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.subscribeToSortBy();
  }

  ngOnChanges() {}

  private subscribeToSortBy() {
    if (this.sortBy$) {
      this.sortBy$
        .pipe(
          tap((s) => {
            this.toggleSortDirection();
            this.resetActive(s);
            this.emitChanges();
            this.resetSortDirection();
            this.cd.detectChanges();
          })
        )
        .subscribe();
    }
  }

  private toggleSortDirection() {
    if (this.isActive) {
      this.sortAsc = !this.sortAsc;
    }
  }

  private emitChanges() {
    if (this.isActive) {
      this.onChangeSort.emit({
        id: this.id,
        isAsc: this.sortAsc,
      });
    }
  }

  private resetActive(sortBy) {
    this.isActive = sortBy === this.id;
  }

  private resetSortDirection() {
    if (!this.isActive) {
      this.sortAsc = true;
    }
  }
}
